import { render, staticRenderFns } from "./CarParksPage.vue?vue&type=template&id=22dfcd82&scoped=true&"
import script from "./CarParksPage.vue?vue&type=script&lang=js&"
export * from "./CarParksPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dfcd82",
  null
  
)

export default component.exports